import React, { useState, useRef } from "react";
import api, { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const FileUpload = ({ value, onChange, accept = "image/*", kind = "image", testId }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("फ़ाइल अपलोड हो गई");
    } catch (err) {
      toast.error("अपलोड विफल: " + (err.response?.data?.detail || err.message));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept={accept} onChange={handleFile} className="hidden" data-testid={testId} />
      {value ? (
        <div className="relative inline-block">
          {kind === "image" ? (
            <img src={fileUrl(value)} alt="preview" className="w-28 h-36 object-cover rounded-lg border border-amber-200" />
          ) : (
            <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
              <FileText size={20} className="text-amber-600" />
              <span className="text-sm text-slate-600">PDF अपलोड हो गया</span>
            </div>
          )}
          <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center">
            <X size={14} />
          </button>
        </div>
      ) : (
        <Button type="button" variant="outline" disabled={uploading} onClick={() => inputRef.current?.click()}
          className="border-amber-300 text-amber-700 hover:bg-amber-50 gap-2">
          {uploading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
          {uploading ? "अपलोड हो रहा है..." : kind === "image" ? "छवि अपलोड करें" : "PDF अपलोड करें"}
        </Button>
      )}
    </div>
  );
};
